import { Flex } from "antd5";
import { type ReactElement, type ReactNode } from "react";

interface PageTitlePropsType {
  title: string;
  /** Right-hand slot: only table pages that can add items use it. */
  actions?: ReactNode;
  /** A second row below the title: status tags, a line of text, a count. */
  subtitle?: ReactNode;
  /** The inset the content below carries. Off for a page that insets nothing. */
  inset?: boolean;
  /** A TableWithFilters below: 5px more inset, and a bigger gap. */
  table?: boolean;
  /** The page's width cap, so the title lines up with the content below. */
  className?: string;
}

/** Page title row. Typography comes from the global `h1`. */
export default function PageTitle({
  title,
  actions,
  subtitle,
  inset = true,
  table,
  className,
}: PageTitlePropsType): ReactElement {
  const classNames = [
    "page-title",
    inset ? "page-title--inset" : "",
    table ? "page-title--table" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classNames}>
      <Flex justify="space-between" align="center" className="page-title__row">
        <h1>{title}</h1>
        {actions}
      </Flex>
      {subtitle && (
        <Flex align="center" gap={8} className="page-title__subtitle">
          {subtitle}
        </Flex>
      )}
    </div>
  );
}
